import appEnums from 'enums/app';
import appEvents from 'events/app';
import { getChatClientConnectionStatus, getAuthError, getServerError } from 'app/modules';
import checkAuth from 'actions/user/checkAuth';

export default (async function reconnectChatClient(dispatch, getState, { chatGateway }) {
  let state = getState();
  let chatClientConnectionState = getChatClientConnectionStatus(state);
  const hasAuthError = getAuthError(state) != null;
  const hasServerError = getServerError(state) != null;
  if (hasAuthError || hasServerError) {
    await dispatch(checkAuth);
    return;
  }
  if (chatClientConnectionState === appEnums.chatClientConnectionStatuses.CONNECTED) {
    return;
  }
  dispatch(appEvents.chatClientReconnect());
  await chatGateway.reconnect();
});
